mutation messageResponseUpdate($first: Int $input: MessageResponseUpdateInput!) {
  messageResponseUpdate(input: $input) {
    query {
      userMessages(first: $first, orderBy: _CREATED_DATE_DESC) {
        nodes {
          id
          _rowTimestamp
          _createdDate
          messageComment
          _isIncomingMessage
          _isOutgoingMessage
          _sendingUser
          _recipientUser
          _notificationTitle
          _isUpdatable
          isResponseRequired
          linkId
          linkTitle
          linkType
          _respondedDate
          messageResponse
        }
      }
    }
  }
}